import React, { useEffect, useState, useContext } from 'react'
import PhoneInput from "react-phone-input-2";
import { useProcessor } from '../../hooks/useProcessor';
import { useShareFiado } from '../../hooks/useShareFiado';
import FInput from '../../components/FInput/FInput';
import { useFormik } from "formik";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import FInputt from '../../components/FInputt/FInputt';
import { v4 as uuidv4 } from 'uuid';
import { useContacts } from '../../hooks/useContacts';
import { concat, map } from 'lodash';
import { usePhoneFormat } from '../../hooks/usePhoneFormat';
import FContainer from '../../components/FContainer/FContainer';
import FInputText from '../../components/Finputs/FInputText/FInputText';
import Fbutton from '../../components/Finputs/FButton/Fbutton';
import Swal from 'sweetalert2';
import FcardContact from '../../components/FcardContact/FcardContact';

export const ApplyForQrFormScreen = () => {
    const route = useNavigate();

    
    const formik = useFormik({
        initialValues: {
            amount: 0,
            concept: '',
        },
        onSubmit: (values) => {
            route("/ApplyForQrScreen", {
                state: {
                    amount:values.amount,
                    concept:values.concept
                },
            });
        },
        validate: (values) => {

            const errors = {};

            if (values.amount == 0) {
                errors.amount = "El monto debe ser mayor a 0";
            }


            if (values.concept == '') {
                errors.concept = "Ingresa el concepto.";
            }

            return errors;
        },
    })


    useEffect(() => {
        formik.setFieldValue(
            "number",
            ""
        );
    }, [])



    return (
        <>
            <FContainer>
                <FInputText
                    type="CurrencyInput"
                    title={"Cantidad (MXN)"}
                    laceholder="¿Cuánto?"
                    value={formik.values.amount}
                    maxLength={10}
                    onChange={async (value) => {
                        formik.setFieldValue("amount", value == undefined ? 0 : value);

                    }}
                    errorMessage={
                        formik.errors.amount
                    }
                />
                <FInputText title={"Concepto"} placeholder={"Concepto"} value={formik.values.concept} onChange={(value) => {
                    formik.setFieldValue(
                        "concept",
                        value
                    );
                }} />

                <Fbutton
                    value={"Crear QR"}
                    disabled={!formik.isValid}
                    onClick={formik.handleSubmit}
                />
            </FContainer>
        </>
    )
}
